import GestureAbstract from './abstract';

export default class GestureDraw extends GestureAbstract {
  constructor (canvas) {
    super(canvas);

    // Freehand drawing
    this.start = { x: 0, y: 0 };
    this.end = { x: 0, y: 0 };
    this.d_attr = null;
    this.freehand = {
      minx: null,
      miny: null,
      maxx: null,
      maxy: null
    };
    this.controllPoint2 = { x: 0, y: 0 };
    this.controllPoint1 = { x: 0, y: 0 };
    this.STEP_COUNT = 10;
    this.THRESHOLD_DIST = 0.8;

    this.sumDistance = 0;
  }

  init (mouse_x, mouse_y, mouseTarget, isRightClick, event) {
    INKIVE.GestureAbstract.prototype.init.call(this, mouse_x, mouse_y, mouseTarget, isRightClick, event);

    const that = this;
    const canvas = that.canvas;
    const cur_properties = canvas.cur_properties;

    switch (canvas.getMode()) {
      case 'fhellipse':
      case 'fhrect':
      case 'fhpath':
        that.start.x = that.r_start_x;
        that.start.y = that.r_start_y;
        canvas.started = true;
        that.d_attr = that.r_start_x + ',' + that.r_start_y + ' ';
        var stroke_w = cur_properties.stroke_width == 0 ? 1 : cur_properties.stroke_width;
        canvas.addSvgElementFromJson({
          element: 'polyline',
          curStyles: true,
          attr: {
            points: that.d_attr,
            id: canvas.getNextId(),
            fill: 'none',
            opacity: cur_properties.opacity / 2,
            'stroke-linecap': 'round',
            style: 'pointer-events:none'
          }
        });
        that.freehand = {
          minx: that.r_start_x,
          maxx: that.r_start_x,
          miny: that.r_start_y,
          maxy: that.r_start_y
        };
        break;
      case 'square':
      // FIXME: once we create the rect, we lose information that this was a square
      // (for resizing purposes this could be important)
      case 'rect':
        canvas.started = true;
        canvas.addSvgElementFromJson({
          element: 'rect',
          curStyles: true,
          attr: {
            x: that.start_x,
            y: that.start_y,
            width: 0,
            height: 0,
            id: canvas.getNextId(),
            opacity: cur_properties.opacity / 2
          }
        });
        break;
      case 'line':
        canvas.started = true;
        var stroke_w = cur_properties.stroke_width == 0 ? 1 : cur_properties.stroke_width;
        canvas.addSvgElementFromJson({
          element: 'line',
          curStyles: true,
          attr: {
            x1: that.start_x,
            y1: that.start_y,
            x2: that.start_x,
            y2: that.start_y,
            id: canvas.getNextId(),
            stroke: cur_properties.stroke,
            'stroke-width': stroke_w,
            'stroke-dasharray': cur_properties.stroke_dasharray,
            'stroke-linejoin': cur_properties.stroke_linejoin,
            'stroke-linecap': cur_properties.stroke_linecap,
            'stroke-opacity': cur_properties.stroke_opacity,
            fill: 'none',
            opacity: cur_properties.opacity / 2,
            style: 'pointer-events:none'
          }
        });
        break;
      case 'circle':
        canvas.started = true;
        canvas.addSvgElementFromJson({
          element: 'circle',
          curStyles: true,
          attr: {
            cx: that.start_x,
            cy: that.start_y,
            r: 0,
            id: canvas.getNextId(),
            opacity: cur_properties.opacity / 2
          }
        });
        break;
      case 'ellipse':
        canvas.started = true;
        canvas.addSvgElementFromJson({
          element: 'ellipse',
          curStyles: true,
          attr: {
            cx: that.start_x,
            cy: that.start_y,
            rx: 0,
            ry: 0,
            id: canvas.getNextId(),
            opacity: cur_properties.opacity / 2
          }
        });
        break;
      case 'path':
        canvas.pathActions.mouseDown(event, mouseTarget, mouse_x, mouse_y);
        canvas.started = true;
        break;
    }
  }

  update (r_mouse_x, r_mouse_y, event) {
    const shiftKey = event.shiftKey;
    const that = this;
    const canvas = that.canvas;
    const current_zoom = canvas.getZoom();

    r_mouse_x = r_mouse_x / current_zoom;
    r_mouse_y = r_mouse_y / current_zoom;

    const spanned = this.getSnappendCoordinates(r_mouse_x, r_mouse_y);
    let mouse_x = spanned[0];
    let mouse_y = spanned[1];

    const shape = svgedit.utilities.getElem(canvas.getId());

    const current_mode = canvas.getMode();
    switch (current_mode) {
      case 'line':
      // Opera has a problem with suspendRedraw() apparently
        var handle = null;
        if (!window.opera) {
          svgroot.suspendRedraw(1000);
        }

        var x2 = mouse_x;
        var y2 = mouse_y;

        if (shiftKey) {
          var xya = svgedit.math.snapToAngle(that.start_x, that.start_y, x2, y2);
          x2 = xya.x;
          y2 = xya.y;
        }

        shape.setAttributeNS(null, 'x2', x2);
        shape.setAttributeNS(null, 'y2', y2);
        if (!window.opera) {
          svgroot.unsuspendRedraw(handle);
        }

        break;
      case 'foreignObject':
      // fall through
      case 'square':
      // fall through
      case 'rect':
      // fall through
      case 'image':
        var square = (current_mode == 'square') || shiftKey;
        var w = Math.abs(mouse_x - that.start_x);
        var h = Math.abs(mouse_y - that.start_y);
        var new_x; var new_y;
        if (square) {
          w = h = Math.max(w, h);
          new_x = that.start_x < mouse_x ? that.start_x : that.start_x - w;
          new_y = that.start_y < mouse_y ? that.start_y : that.start_y - h;
        } else {
          new_x = Math.min(that.start_x, mouse_x);
          new_y = Math.min(that.start_y, mouse_y);
        }

        if (canvas.curConfig.gridSnapping) {
          w = svgedit.utilities.snapToGrid(w);
          h = svgedit.utilities.snapToGrid(h);
          new_x = svgedit.utilities.snapToGrid(new_x);
          new_y = svgedit.utilities.snapToGrid(new_y);
        }

        svgedit.utilities.assignAttributes(shape, {
          width: w,
          height: h,
          x: new_x,
          y: new_y
        }, 1000);

        break;
      case 'circle':
        var c = $(shape).attr(['cx', 'cy']);
        var cx = c.cx;
        var cy = c.cy;
        var rad = Math.sqrt((mouse_x - cx) * (mouse_x - cx) + (mouse_y - cy) * (mouse_y - cy));
        if (canvas.curConfig.gridSnapping) {
          rad = svgedit.utilities.snapToGrid(rad);
        }
        shape.setAttributeNS(null, 'r', rad);
        break;
      case 'ellipse':
        var c = $(shape).attr(['cx', 'cy']);
        var cx = c.cx;
        var cy = c.cy;
        // Opera has a problem with suspendRedraw() apparently
        handle = null;
        if (!window.opera) {
          svgroot.suspendRedraw(1000);
        }

        if (canvas.curConfig.gridSnapping) {
          mouse_x = svgedit.utilities.snapToGrid(mouse_x);
          cx = svgedit.utilities.snapToGrid(cx);
          mouse_y = svgedit.utilities.snapToGrid(mouse_y);
          cy = svgedit.utilities.snapToGrid(cy);
        }

        shape.setAttributeNS(null, 'rx', Math.abs(mouse_x - cx));
        var ry = Math.abs(shiftKey ? (mouse_x - cx) : (mouse_y - cy));
        shape.setAttributeNS(null, 'ry', ry);
        if (!window.opera) {
          svgroot.unsuspendRedraw(handle);
        }
        break;
      case 'fhellipse':
      case 'fhrect':
        that.freehand.minx = Math.min(r_mouse_x, that.freehand.minx);
        that.freehand.maxx = Math.max(r_mouse_x, that.freehand.maxx);
        that.freehand.miny = Math.min(r_mouse_y, that.freehand.miny);
        that.freehand.maxy = Math.max(r_mouse_y, that.freehand.maxy);
      // break; missing on purpose
      case 'fhpath':
        that.end.x = r_mouse_x;
        that.end.y = r_mouse_y;
        if (that.controllPoint2.x && that.controllPoint2.y) {
          for (let i = 0; i < that.STEP_COUNT - 1; i++) {
            const parameter = i / that.STEP_COUNT;
            const nextParameter = (i + 1) / that.STEP_COUNT;
            // {x:0, y:0}
            let bSpline = that._getBsplinePoint(nextParameter);
            // {x:0, y:0}
            const nextPos = bSpline;
            bSpline = that._getBsplinePoint(parameter);
            that.sumDistance += Math.sqrt(
              (nextPos.x - bSpline.x) * (nextPos.x - bSpline.x) +
                        (nextPos.y - bSpline.y) * (nextPos.y - bSpline.y));

            if (that.sumDistance > that.THRESHOLD_DIST) {
              that.d_attr += +bSpline.x + ',' + bSpline.y + ' ';
              shape.setAttributeNS(null, 'points', that.d_attr);
              that.sumDistance -= that.THRESHOLD_DIST;
            }
          }
        }
        that.controllPoint2 = { x: that.controllPoint1.x, y: that.controllPoint1.y };
        that.controllPoint1 = { x: that.start.x, y: that.start.y };
        that.start = { x: that.end.x, y: that.end.y };
        break;
      // update path stretch line coordinates
      case 'path':
      // fall through
      case 'pathedit':
        mouse_x *= current_zoom;
        mouse_y *= current_zoom;

        if (canvas.curConfig.gridSnapping) {
          mouse_x = svgedit.utilities.snapToGrid(mouse_x);
          mouse_y = svgedit.utilities.snapToGrid(mouse_y);
          that.start_x = svgedit.utilities.snapToGrid(that.start_x);
          that.start_y = svgedit.utilities.snapToGrid(that.start_y);
        }
        if (shiftKey) {
          const path = svgedit.path.path;
          let x1, y1;
          if (path) {
            x1 = path.dragging ? path.dragging[0] : that.start_x;
            y1 = path.dragging ? path.dragging[1] : that.start_y;
          } else {
            x1 = that.start_x;
            y1 = that.start_y;
          }
          var xya = svgedit.math.snapToAngle(x1, y1, mouse_x, mouse_y);
          mouse_x = xya.x;
          mouse_y = xya.y;
        }

        if (canvas.rubberBox && canvas.rubberBox.getAttribute('display') !== 'none') {
          r_mouse_x *= current_zoom;
          r_mouse_y *= current_zoom;
          svgedit.utilities.assignAttributes(canvas.rubberBox, {
            x: Math.min(that.r_start_x * current_zoom, r_mouse_x),
            y: Math.min(that.r_start_y * current_zoom, r_mouse_y),
            width: Math.abs(r_mouse_x - that.r_start_x * current_zoom),
            height: Math.abs(r_mouse_y - that.r_start_y * current_zoom)
          }, 100);
        }
        canvas.pathActions.mouseMove(mouse_x, mouse_y);

        break;
    }
  }

  _getBsplinePoint (t) {
    const spline = { x: 0, y: 0 };
    const p0 = this.controllPoint2;
    const p1 = this.controllPoint1;
    const p2 = this.start;
    const p3 = this.end;
    const S = 1.0 / 6.0;
    const t2 = t * t;
    const t3 = t2 * t;

    const m = [
      [-1, 3, -3, 1],
      [3, -6, 3, 0],
      [-3, 0, 3, 0],
      [1, 4, 1, 0]
    ];

    spline.x = S * (
      (p0.x * m[0][0] + p1.x * m[0][1] + p2.x * m[0][2] + p3.x * m[0][3]) * t3 +
    (p0.x * m[1][0] + p1.x * m[1][1] + p2.x * m[1][2] + p3.x * m[1][3]) * t2 +
    (p0.x * m[2][0] + p1.x * m[2][1] + p2.x * m[2][2] + p3.x * m[2][3]) * t +
    (p0.x * m[3][0] + p1.x * m[3][1] + p2.x * m[3][2] + p3.x * m[3][3])
    );
    spline.y = S * (
      (p0.y * m[0][0] + p1.y * m[0][1] + p2.y * m[0][2] + p3.y * m[0][3]) * t3 +
    (p0.y * m[1][0] + p1.y * m[1][1] + p2.y * m[1][2] + p3.y * m[1][3]) * t2 +
    (p0.y * m[2][0] + p1.y * m[2][1] + p2.y * m[2][2] + p3.y * m[2][3]) * t +
    (p0.y * m[3][0] + p1.y * m[3][1] + p2.y * m[3][2] + p3.y * m[3][3])
    );

    return {
      x: spline.x,
      y: spline.y
    };
  }

  destruct (event, mouseX, mouseY) {
    INKIVE.GestureAbstract.prototype.destruct.call(this);

    const that = this;
    const canvas = that.canvas;
    const current_mode = canvas.getMode();

    let element = svgedit.utilities.getElem(canvas.getId());
    let keep = false;

    switch (current_mode) {
      case 'fhpath':
      // Check that the path contains at least 2 points; a degenerate one-point path
      // causes problems.
      // Webkit ignores how we set the points attribute with commas and uses space
      // to separate all coordinates, see https://bugs.webkit.org/show_bug.cgi?id=29870
        that.sumDistance = 0;
        that.controllPoint2 = { x: 0, y: 0 };
        that.controllPoint1 = { x: 0, y: 0 };
        that.start = { x: 0, y: 0 };
        that.end = { x: 0, y: 0 };
        var coords = element.getAttribute('points');
        var commaIndex = coords.indexOf(',');
        if (commaIndex >= 0) {
          keep = coords.indexOf(',', commaIndex + 1) >= 0;
        } else {
          keep = coords.indexOf(' ', coords.indexOf(' ') + 1) >= 0;
        }
        if (keep) {
          element = canvas.pathActions.smoothPolylineIntoPath(element);
        }
        $(element).addClass('element');
        break;
      case 'line':
        var attrs = $(element).attr(['x1', 'x2', 'y1', 'y2']);
        keep = (attrs.x1 != attrs.x2 || attrs.y1 != attrs.y2);
        $(element).addClass('element');
        break;
      case 'foreignObject':
      case 'square':
      case 'rect':
        $(element).addClass('element');
      case 'image':
        var attrs = $(element).attr(['width', 'height']);
        // Image should be kept regardless of size (use inherit dimensions later)
        keep = (attrs.width != 0 || attrs.height != 0) || current_mode === 'image';
        break;
      case 'circle':
        keep = (element.getAttribute('r') != 0);
        $(element).addClass('element');
        break;
      case 'ellipse':
        var attrs = $(element).attr(['rx', 'ry']);
        keep = ((attrs.rx != null && attrs.rx !== 0) || (attrs.ry != null && attrs.ry !== 0));
        $(element).addClass('element');
        break;
      case 'path':
      // set element to null here so that it is not removed nor finalized
        element = null;
        // continue to be set to true so that mouseMove happens
        canvas.started = true;

        var res = canvas.pathActions.mouseUp(event, element, mouseX, mouseY);
        element = res.element;
        keep = res.keep;
        break;
    }

    return [keep, element];
  }
}
